import { createBrowserRouter } from "react-router-dom";
import Main from "../layout/Main";
import Home from "../pages/Home";
import Success from "../pages/Success";
import NotFound from "../404/NotFound";
import CheckoutSuccess from "../pages/CheckoutSuccess";
import SetupSuccess from "../pages/SetupSuccess";
import { siteConfig } from "../constant/siteConfig";
import { toRoutablePath } from "../utils/url";

const sanitizeRoutePath = (configuredPath, fallbackPath) => {
    const routePath = toRoutablePath(configuredPath, fallbackPath);
    return routePath === '/' ? fallbackPath : routePath;
};

const paymentSuccessRoutePath = sanitizeRoutePath(siteConfig.paymentSucceededPagePath, '/success');
const setupSuccessRoutePath = sanitizeRoutePath(siteConfig.setupSucceededPagePath, '/setup-success');

export const route = createBrowserRouter([{
    path: '/',
    element: <Main />,
    errorElement: <NotFound></NotFound>,
    children: [
        {
            path: '/',
            element: <Home></Home>,

        },
        {
            path: paymentSuccessRoutePath,
            element: <Success></Success>
        },
        {
            path: '/checkout-success',
            element: <CheckoutSuccess></CheckoutSuccess>
        },
        {
            path: setupSuccessRoutePath,
            element: <SetupSuccess></SetupSuccess>
        }
    ]
}])
